module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-13.95d013b1.png";